import React from 'react';

import { Species } from '../../api/fishrules/getSpeciesAtLocation';
import { useAllSpeciesAtLocation } from '../../helpers/hooks/fishrules/useAllSpeciesAtLocation';
import { ICoordinates } from '../../interfaces/geo';
import { Heading } from '../Heading/Heading';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { Text } from '../Text/Text';

interface IProps {
  coordinates: ICoordinates;
  species: Species;
}

export const AggregateLimits = ({ coordinates, species }: IProps) => {
  const { isLoading, allSpecies } = useAllSpeciesAtLocation(coordinates);

  if (isLoading) {
    return <LoadingSpinner loadingText="Loading aggregate limits..." />;
  }

  const aggregateLimits = allSpecies.filter(s => s.aggregateName === species.aggregate_name);

  return (
    <>
      <Heading variant="sm" className="mb-4">
        Aggregate limits
      </Heading>
      <Text>
        No recreational harvester shall harvest nor possess more than a total of
        <b>{` ${species.aggregate_limit} ${species.aggregate_name} `}</b>
        per day, in any combination of species listed below:
      </Text>
      <Text className="mb-0">
        <ul className="mb-0 ml-8 list-disc">
          {aggregateLimits.map(s => (
            <li className="body-text-md mb-0 mt-1" key={s.name}>
              {`${s.name} (bag limit: ${s.bagLimit})`}
            </li>
          ))}
        </ul>
      </Text>
    </>
  );
};
